import {defaultPhoneCode, defaultCountry} from "./default";
import {Contact} from "./contact";

export class Owner {
    constructor(owner) {
        this.is_main_principal = '';
        this.is_owner = '';
        this.is_beneficial_owner = '';
        this.directional_owner_type = '';
        this.is_director = '';
        this.is_signatory = '';
        this.owner_title = '';
        this.owner_first_name = '';
        this.owner_second_name = '';
        this.owner_surname = '';
        this.contact_dob = '';
        this.owner_tin_ssn_number = '';
        this.owner_nationality = '';
        this.owner_position = '';
        this.owner_date_started = '';
        this.owner_email = '';
        this.owner_pesel = '';
        this.ownership_perc = '';
        this.directional_ownership_type = '';
        this.is_bank_id_verified = '';

        this.owner_phone_code = defaultPhoneCode;
        this.owner_phone_no = '';
        this.owner_alt_phone_code = defaultPhoneCode;
        this.owner_alt_phone_no = '';
        this.invite_status = '0';
        this.authorised_signatory = '';
        this.ekyc_verification = '0';
        this.idpal_verification = '';
        this.personal_guarantee = '';
        this.address_date_from = '';
        //this.date_to = '';
        this.address_complete = '';
        //this.lived_here_for_3_years = '';
        this.verification_type = '';
        this.contacts = [new Contact()];
        this.is_open = false;
        this.signature_date = '';

        if (!!owner) {
            this.setOwner(owner);
        }
    }

    setOwner(owner) {
        let owner_keys = Object.keys(owner);
        owner_keys.map(f => {
            if (f === 'is_main_principal') {
                this[f] = owner[f].toString();
            } else if(f === 'contacts'){
                this[f] = owner[f].map(obj => new Contact(obj))
            }else {
                this[f] = owner[f]
            }
        });
    }
}


export class Address {
    constructor(address) {

        this.zip_code = '';
        this.house_name = '';
        this.house_number = '';
        this.flat_name = '';
        this.flat_number = '';
        this.street_line_1 = '';
        this.locality = '';
        this.city = '';
        this.county_code = '';
        this.country_code = defaultCountry;
        this.title = '';
        this.first_name = '';
        this.last_name = '';
        this.position = '';
        this.phone_no = '';
        this.email = '';
        this.date_from = '';
        this.date_to = '';
        this.date_to_limit = '';

        if (!!address) {
            this.setAddress(address);
        }
    }

    setAddress(address) {
        let address_keys = Object.keys(address);
        address_keys.map(f => {
            if (f === 'country_code' && address[f] === 'USA'){
                address[f] = '840';
            }
            this[f] = address[f]
        });
    }
}

export class IntermediaryOwner {
    constructor(owner) {
        this.business_name = '';
        this.ownership_percentage = '';

        if (!!owner) {
            this.setOwner(owner);
        }
    }

    setOwner(owner) {
        let owner_keys = Object.keys(owner);
        owner_keys.map(f => {

            this[f] = owner[f]
        });
    }
}
